export const INIT_STATE = "INIT_STATE";
export const UPDATE_APP_POSITION = "UPDATE_APP_POSITION";
export const UPDATE_APP_CLICK_TIME = "UPDATE_APP_CLICK_TIME";